import React from 'react'
import PropTypes from 'prop-types'

import './StatusLabelComponent.scss'

const StatusLabelComponent = ({
  backgroundColor,
  description,
  icon,
  title,
  titleColor,
}) => (
  <div
    className="status-label"
    style={{
      backgroundColor,
    }}
  >
    <div className="status-label-icon">{icon}</div>
    <div className="status-label-title" style={{ color: titleColor }}>
      {title}
    </div>
    <div className="status-label-description">{description}</div>
  </div>
)

StatusLabelComponent.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string.isRequired,
}

// oxlint-disable-next-line import/no-default-export
export default StatusLabelComponent
